"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.module = void 0;
const apis_1 = require("./apis");
const module = { openAuthSessionAsync: apis_1.openAuthSessionAsync };
exports.module = module;
